import * as types from './types'

const intitialState = {
    list: [],
    countUser: {},
}

const enrolReducer = (state = intitialState, action) => {
    switch (action.type) {
        case types.ENROLL_NEW_USER_SUCCESS: {
            return {
                ...state,
                ...action.payload
              }
        }             
        case types.ENROLL_NEW_USER_ERR: {
            return intitialState
        }
        case types.RESET_ENROLL_NEW_USER: {
            return intitialState
        }
        case types.GET_COUNT_USER: {
            return {
                ...state,
                countUser: action.payload
              }
        }    
        default:
            return state;
    }

}

export default enrolReducer